import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spin-icon',
  templateUrl: './spin-icon.component.html',
  styleUrls: ['./spin-icon.component.css']
})
export class SpinIconComponent implements OnInit {

  @Input() spinnerType;

  constructor() { 
    this.spinnerType = "small";
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/spin-icon/spin-icon.component.ts